import { useEffect, useRef } from 'react';
export function useClickToCloseRef(_ref) {
  var isOpen = _ref.isOpen,
    handleClose = _ref.handleClose;
  var ref = useRef(null);
  useEffect(function () {
    var el = ref.current;
    if (!el) {
      return;
    }
    var clickListener = function clickListener() {
      if (isOpen) {
        handleClose(null);
      }
    };
    el.addEventListener('click', clickListener);
    return function () {
      el.removeEventListener('click', clickListener);
    };
  }, [isOpen, handleClose]);
  return ref;
}